import type {
  ActionTypeEntity,
  CreateActionTypePayload,
  CreateActionTypeResponse,
  DeleteActionTypeResponse,
  UpdateActionTypePayload,
  UpdateActionTypeResponse,
} from '@/domains/actionType/actionType.entity';
import type { ActionTypeRepository } from '@/domains/actionType/actionType.repository';
import { actionTypeApiService } from '../http/actionType.api';

/**
 * Repositorio de gestión de tipos de acciones con operaciones CRUD completas
 * Cumple con ISP - Interface Segregation Principle
 */
class ActionTypeApiRepository implements ActionTypeRepository {
  /**
   * Obtiene lista completa de tipos de acciones disponibles en el sistema
   */
  async getActionTypes(): Promise<ActionTypeEntity[]> {
    const response = await actionTypeApiService.getActionTypes();

    if (!response) throw new Error('Error al obtener los tipos de acciones');

    return response;
  }

  /**
   * Crea un nuevo tipo de acción en el sistema
   * @param payload - Datos del nuevo tipo de acción (nombre y descripción)
   */
  async createActionType(
    payload: CreateActionTypePayload,
  ): Promise<CreateActionTypeResponse> {
    const response = await actionTypeApiService.createActionType(payload);

    if (!response) throw new Error('Error al crear el tipo de acción');

    return response;
  }

  /**
   * Actualiza un tipo de acción existente
   * @param cod_tipo_accion - Identificador único del tipo de acción
   * @param payload - Datos actualizados del tipo de acción
   */
  async updateActionType(
    cod_tipo_accion: number,
    payload: UpdateActionTypePayload,
  ): Promise<UpdateActionTypeResponse> {
    const response = await actionTypeApiService.updateActionType(
      cod_tipo_accion,
      payload,
    );

    if (!response) throw new Error('Error al actualizar el tipo de acción');

    return response;
  }

  /**
   * Elimina un tipo de acción del sistema
   * @param cod_tipo_accion - Identificador único del tipo de acción a eliminar
   */
  async deleteActionType(
    cod_tipo_accion: number,
  ): Promise<DeleteActionTypeResponse> {
    const response =
      await actionTypeApiService.deleteActionType(cod_tipo_accion);

    if (!response) throw new Error('Error al eliminar el tipo de acción');

    return response;
  }
}

export const actionTypeApiRepository = new ActionTypeApiRepository();
